import { useTranslation } from 'react-i18next';
// import { useGetCurrentHelpPageUrl } from '@legacy/stores/PageStore/pageStore.zustand';
import { IconButton } from '@legacy/components/mui-components';
import { IconButtonProps } from '@mui/material';
import { HelpOutlineOutlined } from '@mui/icons-material';
import { HELP_URL } from '@/components/global/TopNavigation/components/HelpButton/HelpButton.constants';

interface HelpButtonProps extends IconButtonProps {
  'data-automation-id': string;
}

export const HelpButton = ({ size, ...props }: HelpButtonProps) => {
  const { t } = useTranslation('header');
  // #28475356320 DRO: keep here for reference in the future since it might be used in the new system
  // const helpUrl =  useGetCurrentHelpPageUrl();
  const helpUrl = HELP_URL;
  return (
    <IconButton
      component="a"
      href={helpUrl}
      target="_blank"
      rel="noopener"
      size={size}
      data-automation-id={props['data-automation-id']}
      title={t('HelpSectionLink')}
    >
      <HelpOutlineOutlined />
    </IconButton>
  );
};
